import * as React from "react";
import {PartnerBrandSearch} from "../../../model/partnerBrand/PartnerBrand";
import FilterButton from "./button/FilterButton";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import FilterButtons from "./FilterButtons";
import Filter, {FilterTypeEnum} from "../../../model/workspace/Filter";
import {option, Option} from "ts-option";
import {RootState} from "../../../store/reducer/root/RootState";
import {Dispatch} from "redux";
import {fetchPartnerBrands, savePartnerBrandSearch} from "../../../store/action/partnerBrand/partnerBrand";
import {OnFailure} from "../../../store/action/actionHelpers";
import {connect} from "react-redux";
import {isDefined, notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import Checkbox from "../../../hiberUiKit/src/atoms/Checkbox/Checkbox";
import InputWithIcon from "../../../hiberUiKit/src/atoms/Input/InputWithIcon";
import Loading from "../../ui/loading/Loading";
import IconLarge from "../../../hiberUiKit/src/atoms/Icon/IconLarge";
import {api} from "../../../api/api";
import _ = require("underscore");
import classNames = require("classnames");

interface State {
	filteredItems: PartnerBrandSearch[];
	isFilterConfigVisible?: boolean;
	isNegated: boolean;
	searchText: string;
	selectedItemsIds: string[],
	isLoading: boolean
	itemIdWithFocus: Option<string>;
}

interface ComponentProps {
	filter: Filter;
	onRemove: (refreshData: boolean) => void;
	onChange: (filter: Filter) => void;
	isFilterConfigVisible?: boolean;
}

interface ReduxProps {
	partnerBrands: { [key: string]: PartnerBrandSearch }
}

interface DispatchProps {
	fetchPartnerBrands: (ids: string[], onFailure: OnFailure) => void,
	storePartnerBrandSearch: (pb: PartnerBrandSearch) => void,
}

type Props = ComponentProps & ReduxProps & DispatchProps

class PartnerBrandFilter extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		const selectedItemsIds: string[] = (props.filter.values as Option<string[]>).getOrElse([]);
		this.state =
			{
				filteredItems: this.getSavedItems(),
				isNegated: props.filter.isNegated(),
				isFilterConfigVisible: props.isFilterConfigVisible,
				searchText: "",
				selectedItemsIds,
				isLoading: false,
				itemIdWithFocus: option(selectedItemsIds[0])
			}
	}

	componentDidMount(): void {
		const pbids = (this.props.filter.values as Option<string[]>).getOrElse([]).filter(id => !this.props.partnerBrands[id])
		this.props.fetchPartnerBrands(pbids, e => notifyBugsnagAndShowToast(e, "Fetch partner brands"))
	}

	render() {
		const filterValue = this.getSavedItems();
		const isLoading = this.props.filter.values.isDefined && filterValue.length == 0
		return (
			<div>
				<FilterButton filterName={this.props.filter.columnDefinition.label}
							  onRemove={() => this.props.onRemove(true)}
							  onClick={() => this.setState({isFilterConfigVisible: true, filteredItems: this.getSavedItems()})}
							  filterValue={filterValue.map(pb => pb.name).join(", ")}
							  isDisabled={this.state.isFilterConfigVisible && !isLoading}
							  isLoading={isLoading}
							  isNegated={this.props.filter.isNegated()}/>
				{!isLoading && this.state.isFilterConfigVisible &&

				<DropDownWrapper width={"auto"} onOutsideClick={this.onCancel}>
					<div className={"m-search-dropdown"}>
						<div className={"m-search-dropdown_input"}>
							<InputWithIcon type={"text"}
										   value={this.state.searchText}
										   placeholder={"Type to search ..."}
										   prependIcon={Icon.Search}
										   onChange={this.searchPartnerBrands}
										   focus={true}
										   onConfirm={() => {
											   this.state.itemIdWithFocus.map(iwf => this.isItemSelected(iwf) ?
												   this.unSelect(iwf) : this.onSelect(iwf))

										   }}/>
						</div>
						{this.getNegationCheckbox()}
						<ul>
							{this.state.isLoading ? <Loading isLoading={true} spinnerSize={32}/> :
								<>
									{this.state.filteredItems.map((item, index) => {
										const isItemSelected = this.isItemSelected(item.id);
										const className = classNames({
											"is-focused": this.state.itemIdWithFocus.map(iwf => iwf === item.id).getOrElse(false),
											"is-selected": isItemSelected,
										})
										return (
											<li key={item.id}
												onClick={(e) => {
													e.stopPropagation();
													isItemSelected ? this.unSelect(item.id) : this.onSelect(item.id)
												}}
												onMouseOver={() => this.setState({itemIdWithFocus: option(item.id)})}
												className={className}>
												{item.name}
												{isItemSelected && <IconLarge icon={Icon.CheckMark}/>}
											</li>
										);
									})}
									{
										!this.state.filteredItems.length ?
											this.state.searchText.trim().length ? <li>Not data found</li> :
												!this.state.selectedItemsIds.length && <li>No items selected</li> : null
									}
								</>
							}
						</ul>
					</div>

					<FilterButtons onCancel={this.onCancel} onDone={this.onDone}
								   disabled={!this.state.selectedItemsIds.length}/>
				</DropDownWrapper>}
			</div>
		)
	}

	onCancel = () => {
		this.setState({
			isFilterConfigVisible: false,
			selectedItemsIds: (this.props.filter.values as Option<string[]>).getOrElse([]),
			searchText: "",
			filteredItems: []
		}, () => this.props.filter.values.isEmpty && this.props.onRemove(false));
	}

	onDone = () => {
		const filterType = this.state.isNegated ? FilterTypeEnum.NotIn : FilterTypeEnum.In;
		this.setState({isFilterConfigVisible: false, searchText: "", filteredItems: []},
			() => this.isFilterChanged(filterType)
				&& this.props.onChange(
					this.props.filter.copy(
						{values: option(this.state.selectedItemsIds), type: filterType}))
		)
	}

	isFilterChanged(filterType: FilterTypeEnum) {
		return !_.isEqual(this.props.filter.values.getOrElse([]), this.state.selectedItemsIds) ||
			this.props.filter.type !== filterType
	}

	getSavedItems(props = this.props) {
		const values = props.filter.values as Option<string[]>;
		return values.getOrElse([])
			.map(id => props.partnerBrands[id])
			.filter(item => isDefined(item))
			.sort(PartnerBrandSearch.compare);
	}

	getSelectedItems() {
		return this.state.selectedItemsIds
			.map(id => this.props.partnerBrands[id])
			.filter(item => isDefined(item))
			.sort(PartnerBrandSearch.compare);
	}

	getNegationCheckbox = (): JSX.Element => {
		return (
			<div className={"negation-checkbox"}>
				<Checkbox checked={this.state.isNegated}
						  label={"Is not"}
						  styles={{color: "#112363"}}
						  onChange={(value) => this.setState({isNegated: value})}/>
			</div>)
	}

	searchPartnerBrands = (evt: React.ChangeEvent<HTMLInputElement>) => {
		const searchText = evt.target.value
		const isLoading = !!searchText.trim().length;
		const filteredItems = isLoading ? this.state.filteredItems : this.getSelectedItems()
		this.setState({searchText, isLoading, filteredItems}, () => isLoading &&
			api.instance.partnerBrandApi.findPartnerBrandsByText(searchText).then(
				(items) => this.setState(
					{filteredItems: items, isLoading: false, itemIdWithFocus: option(items[0]).map(pb => pb.id)}))
				.catch(e => notifyBugsnagAndShowToast(e, "Search partner brand")))

	}

	onSelect = (itemId: string) => {
		const [item] = this.state.filteredItems.filter(item => item.id == itemId);
		if (item && !this.props.partnerBrands[itemId]) {
			this.props.storePartnerBrandSearch(item);
		}
		this.setState({selectedItemsIds: this.state.selectedItemsIds.concat(itemId)});
	}

	unSelect(itemId: string) {
		this.setState({selectedItemsIds: this.state.selectedItemsIds.filter(id => id != itemId)})
	}

	isItemSelected = (itemId: string): boolean => this.state.selectedItemsIds.indexOf(itemId) > -1
}

function mapStateToProps(state: RootState) {
	const partnerBrands = state.partnerBrand.partnerBrandsSearchMap
	return {
		partnerBrands
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		storePartnerBrandSearch: (pb: PartnerBrandSearch) => dispatch(savePartnerBrandSearch(pb)),
		fetchPartnerBrands: (pbId: string[], onFailure: OnFailure) => dispatch(fetchPartnerBrands(pbId, () => {}, onFailure))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PartnerBrandFilter);